import { render, staticRenderFns } from "./AppBoxContent.vue?vue&type=template&id=5613c634&scoped=true"
import script from "./AppBoxContent.vue?vue&type=script&lang=js"
export * from "./AppBoxContent.vue?vue&type=script&lang=js"
import style0 from "./AppBoxContent.vue?vue&type=style&index=0&id=5613c634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613c634",
  null
  
)

export default component.exports